module.exports = __webpack_public_path__ + "422953aa4a5099d7496dc07664768208.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/quiz-2.png
// module id = 1753
// module chunks = 0